module.exports = __webpack_public_path__ + "6bde7cb30cf41c6bacc3fa36aa9e0366.jpg";